let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1GWUI")).then(() => parcelRequire('12kIx'));